import React from 'react';

import Loader from 'components/Elements/Loader';

import withPreview from '@/hoc/withPreview';
import conf from 'settings/pageTemplate';
import Page404 from '@/pages/404.jsx';

const Page = ({ pageContext, loaded }) => {
  if (!loaded) return <Loader />;

  const { page } = pageContext;
  const Component = conf[page.template.templateName];

  if (!Component) return <Page404 />;

  return <Component {...pageContext} />;
};

const querySLUG = `query PageTemplatePreviewQuery($slug: ID! = "") {
    page(id: $slug idType: URI) {
      language {
    name
    code
    slug
    locale
  }
  uri
  link
  template {
    templateName
  }
  seo {
    canonical
    fullHead
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphSiteName
    opengraphTitle
    readingTime
    opengraphUrl
    opengraphType
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      altText
      fileSize
    }
    twitterImage {
      sourceUrl
      altText
    }
  }
  featuredImage {
    node {
      sourceUrl
      srcSet
    }
  }
  template {
    ... on Template_Homepage {
      homepage {
        heroTitle
  heroTitleHighlighted
  heroDescription
  heroTilesItems {
    heroTileItemTitle
    heroTileItemDescription
    heroTileItemLink {
      ... on Page {
        id
        uri
      }
    }
    heroTileItemImage {
      sourceUrl
    }
  }
  solutionTitle
  solutionSubtitle
  solutionAccordeonItems {
    accordeonDescription
    accordeonTitle
  }
  cloudTitle
  cloudSubtitle
  cloudDescription
  cloudLink {
    ... on Page {
      id
      uri
    }
  }
  cloudLinkText
  cloudLogos {
    cloudLogoImage {
      sourceUrl
    }
  }
  featuresTitle
  featuresSubtitle
  featuresLinks {
    featuresLinkSrc {
      ... on Page {
        id
        uri
        link
      }
    }
    featuresLinkText
    fieldGroupName
  }
  featuresListItems {
    featuresListDescription
    featuresListLink {
      ... on Page {
        id
        uri
        link
      }
    }
    featuresListTitle
    featuresListIcon {
      sourceUrl
    }
  }
  testimonialsTitle
  testimonialsSubtitle
  testimonialsLogos {
    testimonialsLogoImg {
      sourceUrl
    }
  }
  testimonialsSlideItems {
    slideItemText
    slideItemInfoInfo
    slideItemInfoAuthor
  }
  blogTitle
  blogSubtitle
      }
    }

    ... on Template_Cirrus_for_gas_stations {
      gas_stations_fields {
        heroTitle
  heroTitleHighlighted
  heroSubtitle
  heroListItems {
    heroListText
  }
      }
    }
  }
      revisions(first:1) {
        nodes {
          language {
    name
    code
    slug
    locale
  }
  uri
  link
  template {
    templateName
  }
  seo {
    canonical
    fullHead
    metaDesc
    metaKeywords
    metaRobotsNofollow
    metaRobotsNoindex
    opengraphAuthor
    opengraphDescription
    opengraphSiteName
    opengraphTitle
    readingTime
    opengraphUrl
    opengraphType
    title
    twitterDescription
    twitterTitle
    opengraphImage {
      altText
      fileSize
    }
    twitterImage {
      sourceUrl
      altText
    }
  }
  featuredImage {
    node {
      sourceUrl
      srcSet
    }
  }
  template {
    ... on Template_Homepage {
      homepage {
        heroTitle
  heroTitleHighlighted
  heroDescription
  heroTilesItems {
    heroTileItemTitle
    heroTileItemDescription
    heroTileItemLink {
      ... on Page {
        id
        uri
      }
    }
    heroTileItemImage {
      sourceUrl
    }
  }
  solutionTitle
  solutionSubtitle
  solutionAccordeonItems {
    accordeonDescription
    accordeonTitle
  }
  cloudTitle
  cloudSubtitle
  cloudDescription
  cloudLink {
    ... on Page {
      id
      uri
    }
  }
  cloudLinkText
  cloudLogos {
    cloudLogoImage {
      sourceUrl
    }
  }
  featuresTitle
  featuresSubtitle
  featuresLinks {
    featuresLinkSrc {
      ... on Page {
        id
        uri
        link
      }
    }
    featuresLinkText
    fieldGroupName
  }
  featuresListItems {
    featuresListDescription
    featuresListLink {
      ... on Page {
        id
        uri
        link
      }
    }
    featuresListTitle
    featuresListIcon {
      sourceUrl
    }
  }
  testimonialsTitle
  testimonialsSubtitle
  testimonialsLogos {
    testimonialsLogoImg {
      sourceUrl
    }
  }
  testimonialsSlideItems {
    slideItemText
    slideItemInfoInfo
    slideItemInfoAuthor
  }
  blogTitle
  blogSubtitle
      }
    }

    ... on Template_Cirrus_for_gas_stations {
      gas_stations_fields {
        heroTitle
  heroTitleHighlighted
  heroSubtitle
  heroListItems {
    heroListText
  }
      }
    }
  }
        }
      }
    }
}`;

export default withPreview(Page, '/', { querySLUG });
